import { memo } from "react";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { useActionContext } from "../../providers";

const Approve = () => {
    const { approve } = useActionContext();

    return (
        <ListItem
            disablePadding
        >
            <ListItemButton
                onPointerDown={approve}
            >
                <ListItemIcon>
                    <ThumbUpIcon
                        color='success'
                    />
                </ListItemIcon>
                <ListItemText
                    sx={{
                        color: 'success.main'
                    }}
                    primary='Approve'
                />
            </ListItemButton>
        </ListItem>
    );
};

export default memo(Approve);
